// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f05c90ea","396":"bcd1096c","437":"05087af0","593":"85b72d7d","673":"01f21972","739":"8f2cfbf9","965":"5dcf71be"}[chunkId] + ".chunk.js";
};